// extracted by mini-css-extract-plugin
export var altButtonStyle = "index-module--altButtonStyle--16PNn";
export var defaultButtonStyle = "index-module--defaultButtonStyle--6sl72";
export var defaultButtonStyleA = "index-module--defaultButtonStyleA--Tg0Hx";
export var defaultButtonStyleB = "index-module--defaultButtonStyleB--n0Q0J";
export var ipColumn = "index-module--ipColumn--CCYdy";
export var ipColumnContainer = "index-module--ipColumnContainer--vZiD2";
export var ipDark = "index-module--ipDark--vGCj4";
export var ipHeadingContainer = "index-module--ipHeadingContainer--uwwuo";
export var ipHeadingImageContainer = "index-module--ipHeadingImageContainer--p6bd4";
export var ipInnerContainer = "index-module--ipInnerContainer--2WtUR";
export var ipOuterContainer = "index-module--ipOuterContainer--PVDAN";
export var ipTextContainer = "index-module--ipTextContainer--R4gwp";